import React from 'react'
import "./HisabBook_Hero.css";
import HisabBookHero from '../../../Img/hisabbookhero.png'
// import { Link } from "react-router-dom";

const HisabBook_Hero = () => {
  return (
    <section className="hero_cover">
      <div className="container">
        <div className="hero_cover_content">
          <div className="row">
            <div className="col-sm-6">
              <div className="hero_cover_left">
                <div className="hero_cover_im">
                  {/* Insert image if needed */}
                </div>
                <h1 className="hero_cover_hd">
                  <span>Simplify Your Business with Hisab Book</span>
                </h1>
                <div className="hero_cover_desc">
                  <p>Manage your accounts, transactions, and ledgers seamlessly. Hisab Book ensures secure, accurate, and efficient financial tracking, empowering businesses to thrive with smart digital tools at their fingertips.</p>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="hero_cover_right">
                <div className="hero_cover_img">
                <img src={HisabBookHero} alt="" />
                  {/* Insert image if needed */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HisabBook_Hero